export default {
  yellowFolder: `${process.env.PUBLIC_URL}/images/yellow_folder.png`,
  blueFolder: `${process.env.PUBLIC_URL}/images/blue_folder.png`,
  greenFolder: `${process.env.PUBLIC_URL}/images/green_folder.png`,
  defaultCategory: `${process.env.PUBLIC_URL}/images/default_category.png`,
};
